module.exports = __webpack_public_path__ + "img/pphz-iconM.c12ab237.png";